var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payments-editor-header",attrs:{"slot":"header"},slot:"header"},[_c('icon',{staticClass:"ms-help",attrs:{"size":"16","type":"md-document"}}),_c('span',{staticClass:"ms-help",staticStyle:{"margin-left":"4px"}},[_vm._v("\n    "+_vm._s(_vm.getTitle())+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }